import React from "react";

const NotFound = () => {
  return<div class="page-container">
    <h1 class="page-title">404 - Page Not Found</h1>
    </div>
};

export default NotFound;
